export default __webpack_public_path__ + "static/media/BCA28.9777dbfc.jpg";